import React from 'react';

import { ReportTemplate } from 'api/endPoints/GetReportTemplateList';

import { Modal } from 'components/DesignSystem/Modal';
import { Button } from 'components/common';
import { CreateReportFromTemplateForm } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateForm/CreateReportFromTemplateForm';
import { useCreateReportFromTemplateModalLogic } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateModal.logic';
import { useCreateReportFromTemplateModalProvider } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateModal.provider';

interface Props {
    isShowModal: boolean;
    closeModal: () => void;
    template: ReportTemplate | null;
}

export const CreateReportFromTemplateModal = ({ isShowModal, closeModal, template }: Props) => {
    const { api } = useCreateReportFromTemplateModalProvider();
    const { logic } = useCreateReportFromTemplateModalLogic({ template, api, closeModal });

    return (
        <Modal
            open={isShowModal}
            onClose={() => logic.hideModal()}
            title={'Configure your Template Report'}
            actions={
                <>
                    <Button size={'large'} variant={'secondary'} onClick={() => logic.hideModal()}>
                        Cancel
                    </Button>
                    <Button
                        size={'large'}
                        variant={'primary'}
                        type={'submit'}
                        isLoading={api.createReportFromTemplate.instance.isLoading}
                        onClick={logic.form.handleSubmit(logic.handleSubmitForm)}
                    >
                        Create report
                    </Button>
                </>
            }
        >
            <CreateReportFromTemplateForm api={api} logic={logic} />
        </Modal>
    );
};
